import React from 'react';

import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import Badge from '@mui/material/Badge';

import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';

function ModernHeaderIconButtons(): JSX.Element {
	return (
		<Stack direction="row" spacing={1}>
			<Tooltip title="Admin">
				<IconButton sx={{ backgroundColor: 'var(--csmd-cl-bg-icon_button)' }}>
					<AdminPanelSettingsOutlinedIcon />
				</IconButton>
			</Tooltip>
			<Tooltip title="Account">
				<IconButton sx={{ backgroundColor: 'var(--csmd-cl-bg-icon_button)' }}>
					<PersonOutlineOutlinedIcon />
				</IconButton>
			</Tooltip>
			<Tooltip title="Cart">
				<IconButton sx={{ backgroundColor: 'var(--csmd-cl-bg-icon_button)' }}>
					<Badge color="primary" badgeContent={3}>
						<ShoppingCartOutlinedIcon />
					</Badge>
				</IconButton>
			</Tooltip>
		</Stack>
	);
}

export default ModernHeaderIconButtons;
